// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var EmailNotificationsEventsController = function ($scope, EmailNotificationsEvents, gettextCatalog, gettext) {
    $scope.settings = EmailNotificationsEvents.get();

    $scope.saveList = function () {

        if ($scope.adminOrInRole(['Templates'])) {
            $scope.settings.$update({}, function () {
                $scope.notifySuccess();
            }, function () {
                $scope.notify("error", gettextCatalog.getString(gettext('An error occurred')));
            });
        }
    }
};
EmailNotificationsEventsController.$inject = ['$scope', 'EmailNotificationsEvents', 'gettextCatalog', 'gettext'];
